module.exports = __webpack_public_path__ + "img/teacher_img1.122a46d4.png";